import api from './axiosInstance';
import { BASE_URL } from './config';

// GET
export const fetchSchemas = () => api.get(`${BASE_URL}/schema-config`);

// POST
export const createSchema = (schema) => api.post(`${BASE_URL}/schema-config`, schema);

// PUT
export const updateSchema = (schema) => api.put(`${BASE_URL}/schema-config`, schema);

// DELETE
export const deleteSchema = (id) => api.delete(`${BASE_URL}/schema-config/${id}`);
